import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DSModal from '../designSystem/DSModal';
import { PATHS } from '../../routes/paths';
import { getMissingSettlementRegisterTabTarget } from '../../Utils/settlementDocsNavigation';
import type { UserProfile } from '../../Module/User/Domain/entity/UserTypes';

interface MissingDocumentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  userProfile?: UserProfile | null;
}

const MissingDocumentsModal: React.FC<MissingDocumentsModalProps> = ({
  isOpen,
  onClose,
  userProfile,
}) => {
  const { t } = useTranslation('translation');
  const navigate = useNavigate();

  const handleConfirm = () => {
    const tabTarget = userProfile
      ? getMissingSettlementRegisterTabTarget(userProfile)
      : ('bank' as const);
    onClose();
    navigate(`${PATHS.MY_ACCOUNT}?tab=${tabTarget}`);
  };

  return (
    <DSModal
      open={isOpen}
      size="compact"
      title={t('common.missingDocumentsModal.title', '정산 서류 등록이 필요해요')}
      description={
        <>
          {t('common.missingDocumentsModal.description1', '모금액 정산을 위해 통장 사본과')}
          <br />
          {t('common.missingDocumentsModal.description2', '신분증 사본이 필요해요.')}
        </>
      }
      descriptionVariant="body16"
      onClose={onClose}
      actions={[
        { label: t('common.actions.later', '나중에'), variant: 'secondary', onClick: onClose },
        { label: t('common.actions.register', '등록하기'), variant: 'primary', onClick: handleConfirm },
      ]}
    />
  );
};

export default MissingDocumentsModal;
